import crypto from 'crypto';
import { get } from './ajax';

export const downloadFile = async (url: string) => {
  const res = await get(url, {
    responseType: 'blob'
  });

  if (res.status !== 200) {
    throw new Error('Error fetching the file');
  }

  const blob = new Blob([res.data], { type: res.headers['content-type'] });
  const href = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = href;
  link.style.display = 'none'; // hiding the link from the user
  link.className = 'temp-link-' + String(crypto.createHash('md5').update(href).digest('hex'));

  // Parse the filename from the Content-Disposition header or fallback to a default name
  const contentDisposition = res.headers['content-disposition'] || '';
  if (contentDisposition) {
    const filename = contentDisposition.split(';')[1]?.split('=')[1]?.replace(/"/g, '') || 'file';

    link.download = filename;
  }

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Release the reference to the object URL after some time
  setTimeout(() => {
    URL.revokeObjectURL(href);
  }, 10000);
};
